import React from 'react';

const WhyUs = () => {
  return (
    <section className="py-5 px-4 border border-gray-400 rounded-4xl bg-gradient-to-r from-indigo-400 to-purple-500 text-white">
      <div className="max-w-4xl mx-auto text-left">
        {/* Header & Subheader */}
        <h2 className="text-7xl mb-10 font-light p-2">Why Us?</h2>
        <p className="text-3xl mb-10 mr-12 font-light">
        We will save your team valuable time and resources. With seamless integration into 
        tools like Google Analytics or Mixpanel, you’ll get actionable, data-driven insights 
        to improve engagement and conversions. Focus on building high-impact features 
        while we continuously optimize your UI for success.
        </p>
        
      </div>
    </section>
  );
};

export default WhyUs;